import React from "react";
// import PropTypes from 'prop-types'
import Modal from "@material-ui/core/Modal";

import "./ModalForm.scss";
import Formfield from "../Formfield";
import CustomizedBtn from "../CustomizedBtn";

const ModalForm = ({
  title,
  visible,
  closeModal,
  TxtBtn1,
  TxtBtn2,
  onClickBtn1,
  onClickBtn2,
  floatingLabels,
  children,
  ...rest
}) => {
  const renderFields = () => {
    const {
      onChange,
      id,
      name,
      image,
      address,
      lat,
      long,
      code,
      password,
      profile,
      description,
      pickupPoint = [],
      titleRole,
      roleName,
      error = {},
    } = rest;
    const fields = [];
    let profileSelected = {};
    if (profile && rest.optionsProfile) {
      profileSelected = rest.optionsProfile.find((op) => op.id === profile);
    }
    if (id) {
      fields.push(
        <Formfield
          key="form-field-id"
          name="id"
          value={id}
          onChange={onChange}
          {...(floatingLabels ? { floatingLabel: "Id" } : { label: "Id" })}
          label="Id"
          fullWidth
          inputType="textfield"
        />
      );
    }
    if ("name" in rest) {
      fields.push(
        <Formfield
          key="form-field-name"
          name="name"
          value={name}
          onChange={onChange}
          {...(floatingLabels
            ? { floatingLabel: "Nombre" }
            : { label: "Nombre" })}
          fullWidth
          inputType="textfield"
          error={error.name}
        />
      );
    }
    if ("titleRole" in rest) {
      fields.push(
        <Formfield
          key="form-field-titleRole"
          name="title"
          value={titleRole}
          onChange={onChange}
          label="Titulo"
          {...(floatingLabels
            ? { floatingLabel: "Titulo" }
            : { label: "Titulo" })}
          fullWidth
          inputType="textfield"
          error={error.title}
        />
      );
    }
    if ("description" in rest) {
      fields.push(
        <Formfield
          key="form-field-description"
          name="description"
          value={description}
          onChange={onChange}
          {...(floatingLabels
            ? { floatingLabel: "Descripción" }
            : { label: "Descripción" })}
          fullWidth
          inputType="textfield"
          error={error.description}
        />
      );
    }
    if ("roleName" in rest) {
      fields.push(
        <Formfield
          key="form-field-roleName"
          name="name"
          value={roleName}
          onChange={onChange}
          {...(floatingLabels
            ? { floatingLabel: "Nombre de rol" }
            : { label: "Nombre de rol" })}
          fullWidth
          inputType="textfield"
          error={error.name}
        />
      );
    }
    if ("password" in rest) {
      if (rest.updating) {
        fields.push(
          <Formfield
            color="#EB5757"
            {...(floatingLabels
              ? { floatingLabel: "Contraseña" }
              : { label: "Contraseña" })}
            onClick={rest.onClickBtnPass}
            btnTitle="Cambiar contraseña"
            inputType="button"
          />
        );
      } else
        fields.push(
          <Formfield
            key="form-field-password"
            name="password"
            value={password}
            type="password"
            onChange={onChange}
            {...(floatingLabels
              ? { floatingLabel: "Contraseña" }
              : { label: "Contraseña" })}
            fullWidth
            autoComplete="current-password"
            inputProps={{
              autocomplete: "new-password",
              form: {
                autocomplete: "off",
              },
            }}
            inputType="textfield"
            error={error.password}
          />
        );
    }
    if ("profile" in rest) {
      fields.push(
        <Formfield
          key="form-field-profile"
          name="profile"
          value={profile}
          onChange={onChange}
          {...(floatingLabels
            ? { floatingLabel: "Perfil asignado" }
            : { label: "Perfil asignado" })}
          fullWidth
          inputType="customSelect"
          options={rest.optionsProfile}
          error={error.profile}
        />
      );
    }
    if (
      "pickupPoint" in rest &&
      ["pickuppointop"].includes(profileSelected.name)
    ) {
      // if(profileSelected.name === 'carrier') fields.push (
      //   <Formfield
      //     key='form-field-pickupPoint'
      //     name='pickupPoint'
      //     value={pickupPoint}
      //     onChange={onChange}
      //     disabled={!profile}
      //     label='Ubicaciones'
      //     fullWidth
      //     inputType={'multiSelect'}
      //     options={rest.optionsPickups}
      //     error={error.pickupPoint}
      //   />
      // )
      fields.push(
        <Formfield
          key="form-field-pickupPoint"
          name="pickupPoint"
          value={pickupPoint}
          onChange={onChange}
          disabled={!profile}
          {...(floatingLabels
            ? { floatingLabel: "Ubicaciones" }
            : { label: "Ubicaciones" })}
          fullWidth
          inputType={"customSelect"}
          options={rest.optionsPickups}
          error={error.pickupPoint}
        />
      );
    }
    if ("image" in rest) {
      fields.push(
        <Formfield
          key="form-field-image"
          name="image"
          value={image}
          onChange={onChange}
          {...(floatingLabels
            ? { floatingLabel: "URL Imagen" }
            : { label: "URL Imagen" })}
          inputType="textfield"
          error={error.image}
        />
        // <Formfield
        //   key='form-field-image'
        //   name='image'
        //   value={image}
        //   onChange={(e) => onChange(e, 'image')}
        //   label='Imagen'
        //   inputType='uploadImage'
        //   error={error.image}
        // />
      );
    }
    if ("address" in rest) {
      fields.push(
        <Formfield
          key="form-field-addess"
          name="address"
          value={address}
          onChange={onChange}
          {...(floatingLabels
            ? { floatingLabel: "Dirección" }
            : { label: "Dirección" })}
          fullWidth
          inputType="textfield"
          error={error.address}
        />
      );
    }
    // if ('lat' in rest) {
    //   fields.push(
    //     <Formfield
    //       key='form-field-lat'
    //       name='lat'
    //       value={lat}
    //       onChange={onChange}
    //       label='Latitud'
    //       fullWidth
    //       inputType='textfield'
    //       error={error.lat}
    //     />
    //   )
    // }
    // if ('long' in rest) {
    //   fields.push(
    //     <Formfield
    //       key='form-field-long'
    //       name='long'
    //       value={long}
    //       onChange={onChange}
    //       label='Longitud'
    //       fullWidth
    //       inputType='textfield'
    //       error={error.long}
    //     />
    //   )
    // }
    if ("code" in rest) {
      fields.push(
        <Formfield
          key="form-field-long"
          name="code"
          value={code}
          onChange={onChange}
          {...(floatingLabels
            ? { floatingLabel: "Código" }
            : { label: "Código" })}
          fullWidth
          inputType="textfield"
          error={error.code}
        />
      );
    }
    if ("openingTime" in rest) {
      console.log({ rest })
      fields.push(
        <Formfield
          inputType="time"
          {...(floatingLabels
            ? { floatingLabel: "Horario de Apertura" }
            : { label: "Horario de Apertura" })}
          value={rest.openingTime}
          onChange={(e) => { 
            console.log(e);
            onChange(e, "openingTime") }}
          error={error.openingTime}
        />
      );
    }
    if ("closingTime" in rest) {
      fields.push(
        <Formfield
          inputType="time"
          {...(floatingLabels
            ? { floatingLabel: "Horario de Cierre" }
            : { label: "Horario de Cierre" })}
          value={rest.closingTime}
          onChange={(e) => onChange(e, "closingTime")}
          error={error.closingTime}
        />
      );
    }
    if ("leadTime" in rest) {
      fields.push(
        <Formfield
          inputType="textfield"
          name="leadTime"
          type="number"
          {...(floatingLabels
            ? { floatingLabel: "Lead time de expiración(Días)" }
            : { label: "Lead time de expiración(Días)" })}
          value={rest.leadTime}
          onChange={(e) => onChange(e, "leadTime")}
          error={error.leadTime}
        />
      );
    }

    return fields;
  };

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={visible}
      onClose={closeModal}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="modal-form">
        <div className="modal-form-header">
          <h3>{rest.updating ? `Actualizar ${title}` : `Crear ${title}`}</h3>
        </div>
        <div className="modal-form-body">
          <form>
            {renderFields()}
            {children}
          </form>
        </div>
        <div className="modal-form-footer">
          <CustomizedBtn margin="0" onClick={onClickBtn1}>
            {TxtBtn1}
          </CustomizedBtn>
          <CustomizedBtn filled={true} margin="0" onClick={onClickBtn2}>
            {rest.updating ? "Actualizar" : TxtBtn2}
          </CustomizedBtn>
        </div>
      </div>
    </Modal>
  );
};

ModalForm.defaultProps = {
  visible: false,
  TxtBtn1: "CANCELAR",
  TxtBtn2: "CREAR",
};

ModalForm.propTypes = {};

export default ModalForm;
